import "./success.scss";
import "../../src-utilities/header";
import "../../src-utilities/footer";

let successHeading = document.querySelector(".headingclass");
let successText = document.querySelector(".success-text");

const urlParams = new URLSearchParams(window.location.search);
const formParam = urlParams.get("form");
const rawQuery = window.location.search.slice(1);

if (
  formParam === "chargeon-features-guide" ||
  rawQuery.includes("chargeon-features")
) {
  if (successHeading) {
    successHeading.innerHTML = "Check your inbox";
  }
  if (successText) {
    successText.innerHTML =
      "Your ChargeOn Feature List is on its way. If you don't see it within a few minutes, please check your spam or promotions folder.";
  }
} else if (rawQuery === "downloadEguide") {
  if (successText) {
    successText.innerHTML = "Your e-guide has been sent to your mail!";
  }
} else if (rawQuery === "download-succes-story") {
  if (successText) {
    successText.innerHTML =
      "You'll receive the requested customer success story on your email.";
  }
}
